export default "__VITE_ASSET__d604fb7a__"